/* REACT */
import React, { useMemo, useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/nl'

/* COMPONENTS */
import Rating from '../../../ui/rating/rating'
import { Image } from '../../../../components/ui'

/* STORE */

/* STYLES */
import {
  ItemImageWrapper,
  ItemImage,
  Title,
  RatingImage,
  RatingImageWrapper,
  TitleWrapper,
  GridItemWrapper,
  TripTypeWrapper,
  TripTypeOnImage,
  TripDetailsWrapper,
  TripDetailsItemsWrapper,
  GridItemDetailsWrapper,
  Location,
  TripInfoTitle,
  TripInfoWrapper,
  TripInfo,
  TripInfoItem,
  TripInfoAvailibility,
  Keywords,
  CardIconsWrapper,
  CardIcon,
  CardIconText,
  TripInfoOnImageWrapper,
  TripInfoOnImage,
} from './style'

/* UTILS/CONSTANTS*/
import {
  CLOUDFRONT_BASE_URL,
  TRIP_AVAILIBILITY_STATUSES,
  CLIENT_STYLINGS,
} from '../../../../utils/constants'
import { getTranslations } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`

const TripsGrid = ({
  index,
  isLessThanLaptop,
  item,
  language,
  key,
  organizationSlug,
  itemsPerRow,
  organizationDetails,
}) => {
  // SET MOMENT LOCALE TO CURRENT LANGUAGE
  moment.locale(language)

  const PinImage = `${CLOUDFRONT_BASE_URL}/assets/icons/Pin.svg`

  const {
    name,
    images,
    price,
    destinations,
    label_image,
    duration,
    trip_info,
    label_card,
    label_top,
    rating_image,
    keywords,
    rating_value,
    rating_total_value,
  } = item

  const [tripPrice, setTripPrice] = useState(price)
  const [earlyBookingTripPrice, setEarlyBookingTripPrice] = useState(null)
  const [keywordsText, setKeywordsText] = useState(null)
  const [durationInDays, setDurationInDays] = useState(duration)

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  useEffect(() => {
    // SET TRIP PRICE
    if (item?.trip_info?.length) {
      for (let info of item.trip_info) {
        if (info?.selling_price) {
          // SET PRICE IF NOT SET
          setTripPrice(info.selling_price)

          if (info?.duration_in_days && !duration) {
            // SET DURATION IF NOT SET
            setDurationInDays(info.duration_in_days)
          }

          if (info?.early_booking_price) {
            // SET EARLY BOOKING PRICE
            setEarlyBookingTripPrice(info.early_booking_price)
          }
          break
        }
      }
    }

    if (keywords?.length) {
      let keywordsString = ''
      for (let keyword of keywords) {
        if (keywordsString.length > 0) keywordsString += ' | '
        keywordsString += `${keyword}`
      }

      setKeywordsText(keywordsString)
    }
  }, [key])

  const hasTripAvailibilityInfo = useMemo(() => {
    if (item?.trip_info?.length) {
      let hasTripAvailibilityInfo = false
      for (let info of item.trip_info) {
        if (info?.departure_date && info?.travel_availability_status) {
          hasTripAvailibilityInfo = true
          break
        }
      }
      return hasTripAvailibilityInfo
    }
    return false
  }, [key])

  const getAvailibiltyColor = status => {
    if (
      TRIP_AVAILIBILITY_STATUSES.available.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      })
    ) {
      return 'green'
    }

    if (
      TRIP_AVAILIBILITY_STATUSES.full.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      }) ||
      TRIP_AVAILIBILITY_STATUSES.cancelled.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      })
    ) {
      return 'red'
    }

    if (
      TRIP_AVAILIBILITY_STATUSES.guaranteed.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      }) ||
      TRIP_AVAILIBILITY_STATUSES.nearly_full.find(element => {
        return element.toLowerCase() === status.toLowerCase()
      })
    ) {
      return 'orange'
    }
  }

  const getLabelCardIcon = () => {
    switch (label_card.toLowerCase()) {
      case 'fietsen':
        return 'https://zuiderhuis.be/fietsvakanties/wp-content/themes/zuiderhuistheme/assets/img/bike.svg'
      case 'wandelen':
        return 'https://zuiderhuis.be/wandelreizen/wp-content/themes/zuiderhuistheme/assets/img/walk.svg'
      case 'rondreizen':
        return 'https://zuiderhuis.be/groepsreizen/wp-content/themes/zuiderhuistheme/assets/img/travel-bag.svg'
      default:
        return null
    }
  }

  const destinationsText = useMemo(() => {
    if (destinations?.length) {
      let text = ''
      let index = 0
      for (let destination of destinations) {
        if (index) {
          text += `, `
        }
        text += `${destination}`
        index += 1
      }
      return text
    }
    return ''
  }, [destinations])

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper
      target={
        organizationDetails?.openNewTabOnClickthroughGrid ? '_blank' : '_self'
      }
      href={item.url}
      onClick={() => {
        logAction({
          name: 'url_click_grid',
          url: item.url,
          linkLabel: name,
        })
      }}
      itemsPerRow={itemsPerRow}
    >
      <GridItemDetailsWrapper>
        <ItemImageWrapper onMouseDown={e => mouseDownCoords(e)}>
          <ItemImage
            index={index}
            backgroundImage={itemImage}
            label_top={label_top}
          >
            {label_image ? (
              <TripTypeWrapper>
                <TripTypeOnImage>{label_image}</TripTypeOnImage>
              </TripTypeWrapper>
            ) : null}

            {durationInDays || tripPrice ? (
              <TripInfoOnImageWrapper>
                {' '}
                <TripInfoOnImage>{`${
                  durationInDays ? durationInDays : ''
                }`}</TripInfoOnImage>{' '}
                {tripPrice ? (
                  tripPrice && !earlyBookingTripPrice ? (
                    <TripInfoOnImage>{`${`${
                      durationInDays ? ` - ${tripPrice}` : tripPrice
                    }`}`}</TripInfoOnImage>
                  ) : (
                    <>
                      {tripPrice || earlyBookingTripPrice ? (
                        <>
                          <TripInfoOnImage>{`${
                            durationInDays ? ` - ` : ''
                          }`}</TripInfoOnImage>
                          <TripInfoOnImage
                            style={{ textDecoration: 'line-through' }}
                          >
                            {`${tripPrice}`}
                          </TripInfoOnImage>

                          <TripInfoOnImage>
                            {earlyBookingTripPrice}
                          </TripInfoOnImage>
                        </>
                      ) : null}
                    </>
                  )
                ) : null}
              </TripInfoOnImageWrapper>
            ) : null}
          </ItemImage>
        </ItemImageWrapper>

        <TripDetailsWrapper>
          {name || tripPrice || durationInDays ? (
            <TripDetailsItemsWrapper>
              {destinations?.length || label_card ? (
                <CardIconsWrapper>
                  {destinations?.length ? (
                    <CardIcon>
                      {' '}
                      <i
                        class='fa fa-map-marker fa-sm mr-1'
                        style={{
                          marginRight: '3px',
                          lineHeight: '1.2',
                          fontWeight: 700,
                          fontSize: '12px',
                          color: '#9D5C2C',
                        }}
                      ></i>
                      <CardIconText>{destinations[0]}</CardIconText>
                    </CardIcon>
                  ) : null}
                  {label_card ? (
                    <CardIcon style={{ paddingLeft: '10px' }}>
                      {' '}
                      {getLabelCardIcon() ? (
                        <Image
                          src={getLabelCardIcon()}
                          width={'13px'}
                          height={'13px'}
                          radius={'0px'}
                          style={{
                            marginRight: '1px',
                          }}
                        />
                      ) : null}
                      <CardIconText>{label_card}</CardIconText>
                    </CardIcon>
                  ) : null}
                </CardIconsWrapper>
              ) : null}
              {name ? (
                <TitleWrapper>
                  {destinations?.length ? (
                    <Location>{destinationsText}</Location>
                  ) : null}
                  <Title>{name}</Title>
                </TitleWrapper>
              ) : null}
              {rating_image ? (
                <RatingImageWrapper>
                  <RatingImage src={rating_image} alt='rating' />
                </RatingImageWrapper>
              ) : null}
              {keywordsText ? (
                <TitleWrapper>
                  <Keywords>{keywordsText}</Keywords>
                </TitleWrapper>
              ) : null}
              {rating_value && rating_total_value ? (
                <Rating
                  title={getTranslations('reviews')}
                  value={rating_value}
                  total={rating_total_value}
                />
              ) : null}
            </TripDetailsItemsWrapper>
          ) : null}
        </TripDetailsWrapper>
        {hasTripAvailibilityInfo ? (
          <>
            <TripInfoWrapper>
              <TripInfoTitle>
                {getTranslations('departure_dates')}
              </TripInfoTitle>
              {trip_info?.map((info, i) => {
                return (
                  <>
                    {info?.departure_date ? (
                      // ONLY SHOW IF CONTENT IS THERE
                      <TripInfo>
                        <TripInfoItem>
                          {moment(info.departure_date, 'YYYY-MM-DD').format(
                            'D MMM YYYY'
                          )}
                        </TripInfoItem>
                        <TripInfoAvailibility
                          style={{
                            color: getAvailibiltyColor(
                              info.travel_availability_status
                            ),
                            border: `1px solid ${getAvailibiltyColor(
                              info.travel_availability_status
                            )}`,
                          }}
                        >
                          {info.travel_availability_status}
                        </TripInfoAvailibility>
                      </TripInfo>
                    ) : null}
                  </>
                )
              })}
            </TripInfoWrapper>
          </>
        ) : null}
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  organizationDetails: state?.maya?.organizationDetails,
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(TripsGrid)
